import { BridgeFormJSState } from '../../Types';
import { getParameterId } from '../../utils';
import { EnumParamSchema } from '../ParamSchemaTypes';
import { reduceSelectChildren } from './SelectChildrenFromSchema';

export const reduceSelect = (param: EnumParamSchema, parentId: string) => {
  const inputId = getParameterId(param, parentId);
  const isMultiSelect = param.allowArray;
  const getSelectChildren = reduceSelectChildren(inputId, isMultiSelect);
  return (state: BridgeFormJSState) => {
    return param.value.reduce(getSelectChildren, state);
  };
};
